import React, { useState, useEffect, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import '../../../index.css';

import { getSessionAttendanceTime } from '../../../../../../../store/actions/reports';
import { UserActions } from '../../../../../../../store/actions/users';
import chatIcon from '../../../../../../../assets/images/chat.svg';
import ContainerReport from '../../../../ContainerReport';

const AttendanceTimeReportBot = (props) => {
  const {
    match,
    user,
    getSessionAttendanceTime,
    componentData,
    sessionAttandanceTime,
    bot
  } = props;

  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;
  const [timezone, setTimezone] = useState('');

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  },[bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getSessionAttendanceTime(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone
      });
    };
  }, [parentFilter, user, timezone]);

  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {sessionAttandanceTime?.sessions?.total}
          </p>
          <span className="tipo-relatorio">Total</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {sessionAttandanceTime?.sessions?.finalized}
          </p>
          <span className="tipo-relatorio">Contabilizadas</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {sessionAttandanceTime?.sessions?.abandoned}
          </p>
          <span className="tipo-relatorio">Abandonadas</span>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={chatIcon}
      title="Sessões"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    sessionAttandanceTime: state.reports.sessionAttandanceTime,
    bot: state.bots.bot
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { ...UserActions, getSessionAttendanceTime },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AttendanceTimeReportBot)
);
